import { createAction } from '@reduxjs/toolkit'

import { PARTNER360_CONFIGURATION_NAMESPACE } from './constants'
import { I621Form } from './models/I621Form'

export const partnerDataPending = createAction(
  `${PARTNER360_CONFIGURATION_NAMESPACE}/partnerDataPending`
)

export const partnerDataRejected = createAction<string | undefined>(
  `${PARTNER360_CONFIGURATION_NAMESPACE}/partnerDataRejected`
)

/** `keepSelections` for a reload of the same partner and year: the currency, actuals type and
 *  sale type the user picked stay instead of returning to the partner's defaults. */
export const partnerDataFulfilled = createAction(
  `${PARTNER360_CONFIGURATION_NAMESPACE}/partnerDataFulfilled`,
  (payload: I621Form, options: { keepSelections?: boolean } = {}) => ({
    payload,
    meta: { keepSelections: options.keepSelections ?? false },
  })
)
